import { V3SynthMarketKey } from '@kwenta/sdk/constants'

export const V3_DEPOSITABLE_ASSETS: Record<V3SynthMarketKey, string> = {
	SNXUSD: 'snxUSD',
	SNXETH: 'snxETH',
	SNXBTC: 'snxBTC',
	SNXLINK: 'snxLINK',
	SNXOP: 'snxOP',
}

export const V3_DEPOSIT_OPTIONS: { label: string; value: V3SynthMarketKey }[] = Object.keys(
	V3_DEPOSITABLE_ASSETS
).map((key) => ({
	label: V3_DEPOSITABLE_ASSETS[key as V3SynthMarketKey],
	value: key as V3SynthMarketKey,
}))
